import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  padding: 1rem;

  & > h3 {
    font-weight: 600;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark3};
  }
`;
